export enum userRoles {
	ADMIN = 1,
	CLIENT = 2,
	DRIVER = 3,
	COLLECTOR = 4,
	WAREHOUSEMANAGER = 5,
	SUPERDRIVER = 6,
	MANAGER = 7,
	RETURN_WAREHOUSEMANAGER = 8,
	CHATBOT = 9,
	SUPPORT = 10,
	INTERNATIONAL_DRIVER = 14,
	SUBCLIENT = 15,
	REGIONALMANAGER = 16,
	WAREHOUSE = 17,
	FINANCE = 20,
	AGENCIES = 40,
}

export enum orderStatuses {
	REGISTERED = 1,
	WAITING_PICKUP = 2,
	PICKED_UP = 3,
	IN_STORAGE = 4,
	TRANSPORTING = 5,
	DELIVERED = 6,
	REJECTED = 7,
	PENDING = 8,
	AWAITING_WITHDRAWL = 9,
	RETURNED = 10,
	EXCHANGE = 11,
	REDIRECTED = 12,
	RETURN_STORAGE = 13,
	INTERNATIONAL_TRANSPORTING = 14,
	EXCHANGE_RETURN = 15,
	REFUNDED = 16,
	CANCELLED = 17,
}

export enum settlementStatuses {
	REQUESTED = 1,
	PROCESSING = 2,
	TRANSPORTING = 3,
	WITHDRAWN = 4,
	CONFIRMED = 5,
	RETURN_STORAGE = 6,
	DELIVERED = 7,
	PENDING = 8,
}

export enum LoginResponseDocumentation {
	None = 0,
	IdNumberRequired = 1,
	BusinessNumberRequired = 2,
	IdBusinessRequired = 3,
}

export enum documentTypes {
	SETTLEMENT = 9,
	SETTLEMENT_REFUSAL = 10,
}

export enum refundStatuses {
	REQUESTED = 1,
	APPROVED = 2,
	REFUSED = 3,
	REFUNDED = 4,
	PENDING = 5,
	INFORMATION_PROVIDED = 6,
}

export enum ordersettlementStatuses {
	Pa_BARAZUAR = 0,
	PROCESUAR = 1,
	DOREZUAR = 2,
	WITHDRAWN = 3,
}
